/* Module Dependencies */
import React from 'react';
import PropTypes from 'prop-types';

/* Declare the component */
const FilterChiclets = ({ chiclets }) => {
  if (!chiclets || chiclets.length === 0) {
    return null;
  }

  // Display maximum 4 chiclets
  const displayChiclets = chiclets.slice(0, 4);

  return (
    <div className="vve-filter-chiclets-container" data-testid="filter-chiclets-container">
      {displayChiclets.map((chiclet, index) => (
        <div key={`${chiclet.type}-${index}`} className="vve-chiclet" data-testid={`chiclet-${chiclet.type}`}>
          <span className="vve-chiclet-text">{chiclet.label}</span>
        </div>
      ))}
    </div>
  );
};

/* PropTypes */
FilterChiclets.propTypes = {
  chiclets: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  )
};

/* Export component */
export default FilterChiclets;
